<rt-dialog-header [heading]="title" [hasDivider]="true"></rt-dialog-header>
<rt-dialog-body layout>
  <p [innerHTML]="message"></p>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button variant="plain" class="optional danger-on-hover" (click)="discardChanges()">
    <rt-truncate>{{ discardLabel }}</rt-truncate>
  </rt-button>
  <rt-button variant="plain" (click)="cancel()">
    <rt-truncate>{{ cancelLabel }}</rt-truncate>
  </rt-button>
  <div [rtTooltip]="saveDisabled ? saveDisabledTooltip : null">
    <rt-button
      [disabled]="saveDisabled"
      variant="primary"
      [loading]="isLoading"
      (click)="saveChanges()"
    >
      <rt-truncate>{{ saveLabel }}</rt-truncate>
    </rt-button>
  </div>
</rt-dialog-footer>
